import { useState, useEffect, Dispatch, SetStateAction } from 'react';

// ----------------------------------------------------------------------

export default function useLocalStorage<ValueType>(
    key: string,
    defaultValue: ValueType
): [ValueType, Dispatch<SetStateAction<ValueType>>] {
    const [value, setValue] = useState(() => {
        const storedValue = localStorage.getItem(key);

        return storedValue === null ? defaultValue : JSON.parse(storedValue);
    });

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    useEffect(() => {
        const listener = (e: StorageEvent) => {
            if (e.storageArea === localStorage && e.key === key) {
                setValue(e.newValue ? JSON.parse(e.newValue) : e.newValue);
            }
        };
        window.addEventListener('storage', listener);

        return () => {
            window.removeEventListener('storage', listener);
        };
    }, [key]);

    return [value, setValue];
}
